export const pagesConst = [{ title: "Apply online", path: "/apply-online" }];
